import { DeliveryProvider, OrderFulfillmentStatus, OrderMethod } from '../../../../../services/exports/Constants';

export default {
  text: {
    status: {
      [OrderFulfillmentStatus.Rejected]: 'Are you sure?',
    },
    [OrderMethod.Pickup]: 'Has the customer already picked up the order?',
    [OrderMethod.OnSite]: 'Has the customer already picked up the order?',
    [OrderMethod.Delivery]: {
      [DeliveryProvider.Standalone]: 'Has the the order been delivered already?',
      [DeliveryProvider.UberDrive]: 'Has the driver already picked up the order?',
      [DeliveryProvider.FirstDelivery]: 'Has the driver already picked up the order?',
      [DeliveryProvider.WoltDrive]: 'Has the driver already picked up the order?',
    },
  },
  buttons: {
    cancel: 'No, Cancel',
    confirm: 'Yes',
  },
};
